import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0be90505")

_pushScopeId("data-v-0be90505")
const _hoisted_1 = {
  key: 0,
  class: "device-update modal grid center middle"
}
const _hoisted_2 = { class: "device-update-form card grid" }
const _hoisted_3 = { class: "title row center" }
const _hoisted_4 = {
  key: 0,
  class: "error row"
}
const _hoisted_5 = { class: "form-group col-1" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  class: "btn",
  type: "submit"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", { class: "row" }, null, -1)
const _hoisted_9 = { class: "row center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.data)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("h1", null, _toDisplayString(_ctx.$t("update-device-title")), 1)
          ]),
          (_ctx.errorText)
            ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.errorText)), 1))
            : _createCommentVNode("", true),
          _createVNode("form", {
            class: "row",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.update()), ["prevent"]))
          }, [
            _createVNode("div", _hoisted_5, [
              _withDirectives(_createVNode("input", {
                id: "device.name",
                required: "",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.data.name = $event)),
                placeholder: _ctx.$t('device.name')
              }, null, 8, ["placeholder"]), [
                [_vModelText, _ctx.data.name]
              ])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("button", _hoisted_7, _toDisplayString(_ctx.$t("update")), 1)
            ])
          ], 32),
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            _createVNode("a", {
              href: "#",
              class: "small",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, _toDisplayString(_ctx.$t("cancel")), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})